<form novalidate (ngSubmit)="add()" #formProcedures="ngForm">
    <div class="card card-custom gutter-b card-strech" data-card="true" id="kt_card_1">
        <div class="card-header py-2">
            <div class="card-title">
                <h3 class="card-label" (click)="admitted()">Pet Visit List</h3>
            </div>
            <div class="card-toolbar">
                <div class="me-4">

                </div>
                <!-- <button type="submit" class="btn btn-sm btn-primary">
                    <i class="fas fa-plus icon-sm"></i>Add Procedure
                </button> -->
            </div>
        </div>
        <div class="card-body card-scroll h-500px p-1 pt-0">


            <form novalidate (ngSubmit)="onStatInput()" #formAddProcedures="ngForm">

                <!-- Controls row — outside the table to avoid overflow/clipping issues -->
                <div class="d-flex align-items-center flex-wrap mb-2 px-1"
                    style="gap: 8px; position: relative; z-index: 10;">
                    <div class="flex-grow-1" style="min-width: 200px; position: relative;">
                        <input type="text" class="form-control form-control-sm" required
                            *ngIf="this.petService.pet.active !== 'N'"
                            placeholder="Type a code name/category/subcategory/vendor/desc/manuf" autocomplete="off"
                            name="_code_name" (keydown)="search($event)" [(ngModel)]="filterText">
                        <div class="list-group position-absolute w-100"
                            style="max-height: 200px; overflow-y: auto; z-index: 1050;" *ngIf="buscador_activo">
                            <button type="button" class="list-group-item list-group-item-action"
                                *ngFor="let item of suggestedWordsArray" (click)="select(item); statusSelect.click();">
                                {{ item.code_name + " " + item.procedure_desc }}
                            </button>
                        </div>
                    </div>

                    <div style="min-width: 180px;">
                        <select class="form-control form-control-sm" name="_Status" id="_Status" [(ngModel)]="txtchar"
                            required #statusSelect (change)="onStatusSelected($event.target, formAddProcedures)">
                            <option value="" selected>Select a Status</option>
                            <option value="R">R - Request</option>
                            <option value="D">D - Done</option>
                            <option value="F">F - Refund</option>
                            <option value="W">W - Working</option>
                            <option value="C">C - Client request</option>
                            <option value="T">T - Treatment</option>
                            <option value="S">S - Suggested</option>
                            <option value="P">P - Pharm Label</option>
                            <option value="*">* - Brief History</option>
                        </select>
                    </div>

                    <div class="dropdown">
                        <button class="btn btn-sm btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                            data-toggle="dropdown" data-boundary="window" aria-haspopup="true" aria-expanded="false">
                            <i class="fas fa-filter icon-sm"></i> Filter by Status
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item" (click)="filterByStatus('A')">All</a>
                            <a class="dropdown-item" (click)="filterByStatus('R')">R</a>
                            <a class="dropdown-item" (click)="filterByStatus('D')">D</a>
                            <a class="dropdown-item" (click)="filterByStatus('T')">T</a>
                            <a class="dropdown-item" (click)="filterByStatus('F')">F</a>
                            <a class="dropdown-item" (click)="filterByStatus('W')">W</a>
                            <a class="dropdown-item" (click)="filterByStatus('C')">C</a>
                            <a class="dropdown-item" (click)="filterByStatus('S')">S</a>
                            <a class="dropdown-item" (click)="filterByStatus('P')">P</a>
                            <a class="dropdown-item" (click)="filterByStatus('Q')">Q</a>
                        </div>
                    </div>

                    <div style="width: 100px;">
                        <input type="text" class="form-control form-control-sm" name="_estimateText"
                            [(ngModel)]="estimateText" placeholder="0.00" title="Estimate">
                    </div>
                </div>

                <div class="table-responsive">
                    <table class="table align-middle table-bordered my-0">
                        <thead>
                            <tr class="fw-bold fs-6 text-gray-800 table-dark">
                                <th width="5%">

                                </th>
                                <th>
                                    Procedure
                                </th>
                                <th width="30%">
                                    Description
                                </th>
                                <th width="15%">
                                    Done Date
                                </th>
                                <th width="15%">
                                    Req Date
                                </th>

                            </tr>
                        </thead>
                        <ng-container *ngIf="!isLoading; else loadingBlock">
                            <tbody *ngFor="let item of filteredTable; let i = index">
                                <tr class="badge-hand" data-bs-toggle="tooltip" data-placement="top"
                                    [title]="getTooltip(item)" style="font-size: smaller !important;">
                                    <td style="text-align: center;">
                                        <button type="button" class="btn btn-secondary btn-sm btn-icon"
                                            (click)="view(item)" *ngIf="item.children && item.children.length > 0">
                                            <i class="la la-search"></i>
                                        </button>
                                    </td>
                                    <td>
                                        <div class="d-inline-flex align-items-center" style="width: 100%;">
                                            <button type="button"
                                                class="btn btn-secondary btn-sm col-lg-8 col-md-8 col-sm-6"
                                                [ngStyle]="{'background-color': getColor(item.status) }">
                                                {{ item.code_name }}
                                            </button>
                                            <div class="col-lg-4 col-md-4 col-sm-6 dropdown">
                                                <button class="btn btn-sm btn-secondary mr-1 dropdown-toggle"
                                                    type="button" data-toggle="dropdown"
                                                    (click)="positionDropdown($event)"
                                                    [ngStyle]="{'background-color': getColor(item.status) }"
                                                    aria-haspopup="true" aria-expanded="false">
                                                    {{ item.status }}
                                                </button>
                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                    <a class="dropdown-item" (click)="statusChanged(item, button, i)"
                                                        *ngFor="let button of getStatusOption(item.status)">
                                                        {{ button }}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </td>

                                    <td style="vertical-align:middle;">
                                        {{ item.procedure_desc }}
                                    </td>
                                    <td style="vertical-align:middle;">
                                        {{ item.done_date }}
                                    </td>
                                    <td style="vertical-align:middle;">
                                        {{ item.req_date }}
                                    </td>

                                </tr>
                                <tr *ngIf="item.visible">
                                    <td></td>
                                    <td colspan="2">
                                        <table class="table table-borderless table-sm m-0">
                                            <tbody>
                                                <tr class="badge-hand" *ngFor="let child of item.children"
                                                    data-bs-toggle="tooltip" data-placement="top"
                                                    [title]="getTooltip(child)">
                                                    <td>
                                                        <span class="form-control form-control-sm"
                                                            [ngStyle]="{'background-color': getColor(child.status) }">
                                                            {{ child.code_name }} - {{ child.procedure_desc }}
                                                        </span>
                                                    </td>
                                                    <td style="max-width:40px;">
                                                        <div class="dropdown">
                                                            <button
                                                                class="btn btn-secondary btn-sm mr-1 dropdown-toggle"
                                                                type="button" data-toggle="dropdown"
                                                                data-boundary="window"
                                                                [ngStyle]="{'background-color': getColor(child.status) }"
                                                                aria-haspopup="true" aria-expanded="false">
                                                                {{ child.status }}
                                                            </button>
                                                            <div class="dropdown-menu"
                                                                aria-labelledby="dropdownMenuButton">
                                                                <a class="dropdown-item"
                                                                    (click)="statusChangedChild(child, button, i)"
                                                                    *ngFor="let button of getStatusOption(child.status)">
                                                                    {{ button }}
                                                                </a>
                                                            </div>
                                                        </div>

                                                    </td>

                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>

                                </tr>
                            </tbody>
                        </ng-container>
                    </table>

                    <ng-template #loadingBlock>
                        <tbody>
                            <tr>
                                <td class="text-center" colspan="5">
                                    <i class="fas fa-spinner fa-spin icon-xl"></i>&nbsp;&nbsp;&nbsp;
                                    <span class="ms-9 text-primary" style="font-size: 1.17rem !important;">Loading
                                        data...</span>
                                </td>
                            </tr>
                        </tbody>
                    </ng-template>
                </div>
            </form>

            <!-- <div class="table-responsive h-500px">
                <table class="table table-sm table-row-bordered m-0">
                    <thead>
                        <tr>
                            <th class="w-120px">
                                Actions
                            </th>
                            <th>
                                Code
                            </th>
                            <th>
                                Description
                            </th>
                            <th>
                                Status
                            </th>
                            <th>
                                Date Done
                            </th>
                            <th>
                                Date Req
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of filteredTable" class="badge-hand" data-bs-toggle="tooltip"
                            data-placement="top" [title]="getTooltip(item)"
                            [ngStyle]="{'background-color': getColor(item.status) }">

                            <td>
                                <button type="button" class="btn btn-icon btn-secondary btn-sm m-1"
                                    (click)="view(item)">
                                    <i class="la la-pen"></i>
                                </button>
                            </td>

                            <td>
                                {{ item.code_name }}
                            </td>
                            <td>
                                {{ item.procedure_desc }}
                            </td>
                            <td>
                                {{ item.status }}
                            </td>
                            <td>
                                {{ item.done_date }}
                            </td>
                            <td>
                                {{ item.req_date }}
                            </td>
                        </tr>
                    </tbody>

                </table>
            </div> -->
        </div>
    </div>
</form>

<form novalidate (ngSubmit)="proc()" #formProcedureProc="ngForm">
    <div class="modal fade" id="modalProcRefer" tabindex="-1" role="dialog" aria-labelledby="modalProcRefer"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" style="max-width: 1000px;" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="modalNewPetNoteLabel">Procedure</h5>
                    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                        <i aria-hidden="true" class="ki ki-close"></i>
                    </button>
                </div>
                <div class="modal-body">

                    <div>
                        <div class="row row-cols-auto gy-0 gx-6" style="width: -webkit-fill-available;">
                            <div class="col-md-4">
                                <div class="mb-4 row">
                                    <label class="col-sm-3 col-form-label text-lg-end">
                                        Code:
                                    </label>
                                    <div class="col-sm-9">
                                        <input type="text" *ngIf="!edit" class="form-control form-control-solid"
                                            required name="_code_name" readonly
                                            [(ngModel)]="petService.pet_proc.code_name">
                                        <input type="text" *ngIf="edit" class="form-control form-control-solid" required
                                            name="_code_name" (keydown)="search($event)"
                                            [(ngModel)]="petService.pet_proc.code_name">
                                        <div style="background-color: darkgray; position: absolute; z-index: 2; width: 40vw; left: 5%; -moz-border-radius:5px; -webkit-border-radius: 5px; border-radius: 5px; behavior: url(border-radius.htc);"
                                            *ngIf="buscador_activo">
                                            <div class="row text-center  badge-hand"
                                                style="color: #00000F; font-weight: bold; font-size: 14px;"
                                                *ngFor="let item of suggestedWordsArray; let i = index;"
                                                (click)="select(item)">
                                                <div class="col-12 badge-hand">
                                                    <label class="badge-hand">
                                                        {{ item.code_name }} - {{ item.procedure_desc }}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mb-4 row">
                                    <label class="col-sm-3 col-form-label text-lg-end">
                                        Description:
                                    </label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control form-control-solid" required
                                            name="_procedure_desc" [readonly]="!edit"
                                            [(ngModel)]="petService.pet_proc.procedure_desc">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4" *ngIf="edit">
                                <div class="mb-4 row">
                                    <label class="col-sm-3 col-form-label text-lg-end">
                                        Status:
                                    </label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control form-control-solid" required
                                            name="_status" [readonly]="!edit" [(ngModel)]="petService.pet_proc.status">
                                        <!-- <select class="form-control form-control-solid" id="inputGroupSelect02"
                                            name="_note_type" [(ngModel)]="petService.pet_proc.status">
                                            <option value=""></option>
                                            <option *ngFor="let item of status" [value]="item">
                                                {{ item }}
                                            </option>
                                        </select> -->
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4" *ngIf="edit">
                                <div class="mb-4 row">
                                    <label class="col-sm-3 col-form-label text-lg-end">
                                        PStatus:
                                    </label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control form-control-solid" required
                                            name="_pstatus" [readonly]="!edit"
                                            [(ngModel)]="petService.pet_proc.pstatus">
                                        <!-- <select class="form-control form-control-solid" id="inputGroupSelect02"
                                            name="_note_type" [(ngModel)]="petService.pet_proc.status">
                                            <option value=""></option>
                                            <option *ngFor="let item of status" [value]="item">
                                                {{ item }}
                                            </option>
                                        </select> -->
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4" *ngIf="!edit">
                                <div class="mb-4 row">
                                    <label class="col-sm-3 col-form-label text-lg-end">
                                        Req Date:
                                    </label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control form-control-solid" required
                                            name="_req_date" [readonly]="!edit"
                                            [(ngModel)]="petService.pet_proc.req_date">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4" *ngIf="!edit">
                                <div class="mb-4 row">
                                    <label class="col-sm-3 col-form-label text-lg-end">
                                        Appr Date:
                                    </label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control form-control-solid" required
                                            name="_appr_date" [readonly]="!edit"
                                            [(ngModel)]="petService.pet_proc.appr_date">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4" *ngIf="!edit">
                                <div class="mb-4 row">
                                    <label class="col-sm-3 col-form-label text-lg-end">
                                        Done Date:
                                    </label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control form-control-solid" required
                                            name="_done_date" [readonly]="!edit"
                                            [(ngModel)]="petService.pet_proc.done_date">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4" *ngIf="!edit">
                                <div class="mb-4 row">
                                    <label class="col-sm-3 col-form-label text-lg-end">
                                        Inv Date:
                                    </label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control form-control-solid" required
                                            name="_inv_date" [readonly]="!edit"
                                            [(ngModel)]="petService.pet_proc.inv_date">
                                    </div>
                                </div>
                            </div>
                            <!-- </div>
                        <div class="row row-cols-auto gy-0 gx-6" style="width: -webkit-fill-available;" *ngIf="!edit"> -->
                            <div class="col-md-4">
                                <div class="mb-4 row">
                                    <label class="col-sm-3 col-form-label text-lg-end">
                                        Response:
                                    </label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control form-control-solid" required
                                            name="_response1" [readonly]="!edit"
                                            [(ngModel)]="petService.pet_proc.response1">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mb-4 row">
                                    <label class="col-sm-3 col-form-label text-lg-end">
                                        Req:
                                    </label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control form-control-solid" required
                                            name="_req_employee_initial" [readonly]="!edit"
                                            [(ngModel)]="petService.pet_proc.req_employee_initial">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mb-4 row">
                                    <label class="col-sm-3 col-form-label text-lg-end">
                                        Appt:
                                    </label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control form-control-solid" required
                                            name="_appr_employee_initial" [readonly]="!edit"
                                            [(ngModel)]="petService.pet_proc.appr_employee_initial">
                                    </div>
                                </div>
                            </div>
                            <!-- </div>
                        <div class="row row-cols-auto gy-0 gx-6" style="width: -webkit-fill-available;" *ngIf="!edit"> -->
                            <div class="col-md-4">
                                <div class="mb-4 row">
                                    <label class="col-sm-3 col-form-label text-lg-end">
                                        Done:
                                    </label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control form-control-solid" required
                                            name="_done_employee_initial" [readonly]="!edit"
                                            [(ngModel)]="petService.pet_proc.done_employee_initial">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mb-4 row">
                                    <label class="col-sm-3 col-form-label text-lg-end">
                                        Unit:
                                    </label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control form-control-solid" required name="_unit"
                                            [readonly]="!edit" [(ngModel)]="petService.pet_proc.unit">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mb-4 row">
                                    <label class="col-sm-3 col-form-label text-lg-end">
                                        Cost:
                                    </label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control form-control-solid" required name="_cost"
                                            [readonly]="!edit" [(ngModel)]="petService.pet_proc.cost">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mb-4 row">
                                    <label class="col-sm-3 col-form-label text-lg-end">
                                        Chk Cost:
                                    </label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control form-control-solid" required
                                            name="_chk_cost" [readonly]="!edit"
                                            [(ngModel)]="petService.pet_proc.chk_cost">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mb-4 row">
                                    <label class="col-sm-3 col-form-label text-lg-end">
                                        Recall Date:
                                    </label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control form-control-solid" required
                                            name="_recall_date" [readonly]="!edit"
                                            [(ngModel)]="petService.pet_proc.recall_date">
                                    </div>
                                </div>
                            </div>
                            <!-- </div>
                        <div class="row row-cols-auto gy-0 gx-6" style="width: -webkit-fill-available;" *ngIf="!edit"> -->
                            <div class="col-md-4">
                                <div class="mb-4 row">
                                    <label class="col-sm-3 col-form-label text-lg-end">
                                        Route:
                                    </label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control form-control-solid" required
                                            name="_route" [readonly]="!edit" [(ngModel)]="petService.pet_proc.route">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mb-4 row">
                                    <label class="col-sm-3 col-form-label text-lg-end">
                                        Admin:
                                    </label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control form-control-solid" required
                                            name="_admin" [readonly]="!edit"
                                            [(ngModel)]="petService.pet_proc.rerequest">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mb-4 row">
                                    <label class="col-sm-3 col-form-label text-lg-end">
                                        Location:
                                    </label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control form-control-solid" required
                                            name="_location" [readonly]="!edit"
                                            [(ngModel)]="petService.pet_proc.location">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mb-4 row">
                                    <label class="col-sm-3 col-form-label text-lg-end">
                                        Tax:
                                    </label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control form-control-solid" required name="_tax"
                                            [readonly]="!edit" [(ngModel)]="petService.pet_proc.tax">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mb-4 row">
                                    <label class="col-sm-3 col-form-label text-lg-end">
                                        Link No:
                                    </label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control form-control-solid" required
                                            name="_link_no" [readonly]="!edit"
                                            [(ngModel)]="petService.pet_proc.link_no">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mb-4 row">
                                    <label class="col-sm-3 col-form-label text-lg-end">
                                        Link Type:
                                    </label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control form-control-solid" required
                                            name="_link_type" [readonly]="!edit"
                                            [(ngModel)]="petService.pet_proc.link_type">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mb-4 row">
                                    <label class="col-sm-3 col-form-label text-lg-end">
                                        Item Type:
                                    </label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control form-control-solid" required
                                            name="_item_type" [readonly]="!edit"
                                            [(ngModel)]="petService.pet_proc.item_type">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <table class="table table-sm table-row-bordered m-0"
                                *ngIf="petService.pet_proc.children && petService.pet_proc.children.length > 0">
                                <tbody>
                                    <tr>
                                        <td>
                                            <ng-container *ngFor="let item_child of petService.pet_proc.children">
                                                <div class="d-inline-flex align-items-center mb-2"
                                                    (click)="view(item_child, petService.pet_proc)">
                                                    <button type="button" class="btn btn-sm mr-1"
                                                        [ngStyle]="{'background-color': getColor(item_child.status) }"
                                                        data-bs-toggle="tooltip" data-placement="top"
                                                        [title]="getTooltip(item_child)">
                                                        {{ item_child.code_name }}
                                                    </button>
                                                    <div class="dropdown" data-bs-toggle="tooltip" data-placement="top"
                                                        [title]="getTooltip(item_child)">
                                                        <button class="btn btn-secondary btn-sm mr-3 dropdown-toggle"
                                                            type="button"
                                                            [ngStyle]="{'background-color': getColor(item_child.status) }"
                                                            data-toggle="dropdown" aria-haspopup="true"
                                                            aria-expanded="false">
                                                            {{ item_child.status }}
                                                        </button>
                                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                            <a class="dropdown-item"
                                                                *ngFor="let button of getStatusOption(item_child.status)">
                                                                {{ button.desc }}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>

                </div>
                <div class="modal-footer">

                    <button type="button" class="btn btn-info font-weight-bold" *ngIf="isChild" (click)="back()">
                        <!-- <i class="bi bi-save"></i> -->
                        Back
                    </button>
                    <button type="button" class="btn font-weight-bold btn-secondary ml-3" data-bs-dismiss="modal"
                        aria-label="Close">
                        Cancel
                    </button>

                </div>
            </div>
        </div>
    </div>
</form>

<form novalidate (ngSubmit)="applyFilter()" #formAddProcedures="ngForm">
    <div class="modal fade" id="modalAddProc" tabindex="-1" role="dialog" aria-labelledby="modalAddProc"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="modalNewPetNoteLabel">Search Procedure</h5>
                    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                        <i aria-hidden="true" class="ki ki-close"></i>
                    </button>
                </div>
                <div class="modal-body">

                    <div class="row">
                        <div class="col-md-4">
                            <div class="mb-4 row">
                                <label class="col-sm-4 col-form-label text-lg-end">
                                    Category:
                                </label>
                                <div class="col-sm-8">
                                    <select class="form-control no-arrow" id="_txtchar" name="_txtchar"
                                        [(ngModel)]="filterCategory">
                                        <option value=""></option>
                                        <option [value]="item" *ngFor="let item of Categories">
                                            {{ item }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="mb-4 row">
                                <label class="col-sm-4 col-form-label text-lg-end">
                                    SubCategory:
                                </label>
                                <div class="col-sm-8">
                                    <select class="form-control no-arrow" id="_txtchar" name="_txtchar"
                                        [(ngModel)]="filterSubCategory">
                                        <option value=""></option>
                                        <option [value]="item" *ngFor="let item of SubCategories">
                                            {{ item }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="mb-4 row">
                                <label class="col-sm-4 col-form-label text-lg-end">
                                    Approval:
                                </label>
                                <div class="col-sm-8">
                                    <select class="form-control no-arrow" id="_txtchar" name="_txtchar"
                                        [(ngModel)]="filterApproval">
                                        <option value=""></option>
                                        <option [value]="item" *ngFor="let item of Approvals">
                                            {{ item }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="mb-4 row">
                                <label class="col-sm-4 col-form-label text-lg-end">
                                    Type:
                                </label>
                                <div class="col-sm-8">
                                    <select class="form-control no-arrow" id="_txtchar" name="_txtchar"
                                        [(ngModel)]="filterType">
                                        <option value=""></option>
                                        <option [value]="item" *ngFor="let item of Types">
                                            {{ item }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="mb-4 row">
                                <label class="col-sm-4 col-form-label text-lg-end">
                                    Fix:
                                </label>
                                <div class="col-sm-8">
                                    <select class="form-control no-arrow" id="_txtchar" name="_txtchar"
                                        [(ngModel)]="filterFix">
                                        <option value=""></option>
                                        <option [value]="item" *ngFor="let item of Fix">
                                            {{ item }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="mb-4 row">
                                <label class="col-sm-4 col-form-label text-lg-end">
                                    Vendor:
                                </label>
                                <div class="col-sm-8">
                                    <select class="form-control no-arrow" id="_txtchar" name="_txtchar"
                                        [(ngModel)]="filterVendor">
                                        <option value=""></option>
                                        <option [value]="item.vendor" *ngFor="let item of catalogService.codes_vendor">
                                            {{ item.vendor }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="mb-4 row">
                                <label class="col-sm-4 col-form-label text-lg-end">
                                    Code:
                                </label>
                                <div class="col-sm-8">
                                    <select class="form-control form-control-solid col-7 mr-1" name="_ProcCode"
                                        [(ngModel)]="filterText" required (change)="onOptionsSelected($event.target)">
                                        <option value=""></option>
                                        <!-- <option value="Search...">Search...</option> -->
                                        <option *ngFor="let item of codes_file" [value]="item.code_name">
                                            {{ item.code_name }} - {{ item.procedure_desc }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="mb-4 row">
                                <label class="col-sm-4 col-form-label text-lg-end">
                                    Status:
                                </label>
                                <div class="col-sm-8">
                                    <select class="form-control form-control-solid col-4" name="_Status"
                                        [(ngModel)]="txtchar" required>
                                        <option value=""></option>
                                        <option value="R">R</option>
                                        <option value="D">D</option>
                                        <option value="T">T</option>
                                        <option value="F">F</option>
                                        <option value="W">W</option>
                                        <option value="C">C</option>
                                        <option value="S">S</option>
                                        <option value="P">P</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row">
                        <div class="col-10">
                            <div class="mb-4 row">
                                <label class="col-sm-4 col-form-label text-lg-end">
                                    Procedure code:
                                </label>
                                <div class="col-sm-8">
                                    <input type="text" class="form-control form-control-solid" name="filterText"
                                        required autocomplete="off" [(ngModel)]="filterText" (input)="filterItems()"
                                        placeholder="Filter items">
                                </div>
                            </div>
                        </div>

                        <div class="col-2">
                            <div class="mb-4 row">
                                <div class="col-sm-12">
                                    <select class="form-control no-arrow" id="_txtchar" name="_txtchar" required
                                        [(ngModel)]="txtchar">
                                        <option value=""></option>
                                        <option value="X">
                                            X
                                        </option>
                                        <option value="*">
                                            *
                                        </option>
                                        <option value="$">
                                            $
                                        </option>
                                        <option [value]="item" *ngFor="let item of LETTER_PROC">
                                            {{ item }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="list-group button-container" style="max-height: 200px;overflow-y: auto;"
                        *ngIf="!isButtonClicked">
                        <button type="button" class="list-group-item list-group-item-action"
                            *ngFor="let item of filteredItems" (click)="fillTextbox(item.code_name)">
                            {{ item.code_name + " " + item.procedure_desc }}
                        </button>
                    </div> -->


                </div>
                <div class="modal-footer">
                    <button type="button" class="btn font-weight-bold btn-secondary ml-3" data-bs-dismiss="modal"
                        aria-label="Close">
                        Cancel
                    </button>
                    <button type="submit" class="btn btn-primary  font-weight-bold">
                        <i class="bi bi-save"></i>
                        Apply
                    </button>
                </div>
            </div>
        </div>
    </div>
</form>

<form novalidate (ngSubmit)="onVaccine()" #formAddVaccine="ngForm">
    <div class="modal fade" id="modalAddVaccine" tabindex="-1" role="dialog" aria-labelledby="modalAddVaccine"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" style="max-width: 500px;" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="modalNewPetNoteLabel">Vaccine</h5>
                    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                        <i aria-hidden="true" class="ki ki-close"></i>
                    </button>
                </div>
                <div class="modal-body">

                    <div class="form-group">
                        <label>
                            Proc Date:
                        </label>
                        <input type="date" class="form-control form-control-solid" name="_brief_hist_date" required
                            autocomplete="off" [(ngModel)]="petService.pet_brief.brief_hist_date">
                    </div>
                    <div class="form-group">
                        <label>
                            Due Date:
                        </label>
                        <input type="date" class="form-control form-control-solid" name="_brief_hist_date" required
                            autocomplete="off" [(ngModel)]="petService.pet_brief.brief_due_date">
                    </div>
                    <div class="form-group">
                        <label>
                            First Response:
                        </label>
                        <input type="text" class="form-control form-control-solid" name="_brief_hist_resp1" required
                            autocomplete="off" [(ngModel)]="petService.pet_brief.brief_hist_resp1">
                    </div>
                    <div class="form-group">
                        <label>
                            Second Response:
                        </label>
                        <input type="text" class="form-control form-control-solid" name="_brief_hist_resp2" required
                            autocomplete="off" [(ngModel)]="petService.pet_brief.brief_hist_resp2">
                    </div>


                </div>
                <div class="modal-footer">

                    <button type="submit" class="btn btn-primary  font-weight-bold">
                        <i class="bi bi-save"></i>
                        Done
                    </button>
                    <button type="button" class="btn font-weight-bold btn-secondary ml-3" data-bs-dismiss="modal"
                        aria-label="Close">
                        Cancel
                    </button>
                    <button type="submit" class="btn btn-primary  font-weight-bold" [disabled]="formAddVaccine.invalid">
                        <i class="bi bi-save"></i>
                        Add Procedure
                    </button>
                </div>
            </div>
        </div>
    </div>
</form>

<div class="modal fade" tabindex="-1" id="treatmentModal" aria-labelledby="treatmentModal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modalSearchClientLabel">
                    Recurring Treatment
                    <span
                        class="label label-rounded label-warning text-dark label-lg font-weight-bolder label-inline pr-2">
                        <i class="las la-weight font-size-h2 mr-1" style="color: black;"></i>
                        {{ petService.pet_profile_lastentry.weight }} lbs /
                        {{ (petService.pet_profile_lastentry.weight * 0.45359237) | number:'1.2-2' }} kg
                    </span>
                    <button type="button" class="btn btn-sm btn-success mx-5" (click)="addRecurringTreatment()">
                        <i class="la la-plus-circle"></i> Add
                    </button>
                </h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <i aria-hidden="true" class="ki ki-close"></i>
                </button>
            </div>
            <form novalidate (ngSubmit)="saveTreatment()">
                <div class="modal-body">
                    <div class="table-responsive" style="max-width: 1500px">
                        <table class="table table-sm">
                            <tbody>
                                <tr *ngFor="let item of procedureService.tx_setup_array; let index = index">
                                    <td style="max-width: 30px;">
                                        <button type="button" name="Tx_Delete_{{ index }}"
                                            class="btn btn-sm btn-danger"
                                            (click)="deleteRecurringTreatment(index)">
                                            <i class="la la-trash"></i>
                                        </button>
                                    </td>
                                    <td class="text-right" style="vertical-align: middle;">
                                        Start Date
                                    </td>
                                    <td>
                                        <input type="date" class="form-control" name="Tx_StartDate_{{ index }}"
                                            [(ngModel)]="procedureService.tx_setup_array[index].start_date" />
                                    </td>
                                    <td class="text-right" style="vertical-align: middle;">
                                        Frequency
                                    </td>
                                    <td style="max-width: 80px;">
                                        <select class="form-control" name="Tx_Freq_{{ index }}"
                                            [(ngModel)]="procedureService.tx_setup_array[index].no_times">
                                            <option value=""></option>
                                            <option value="0">SID PM</option>
                                            <option value="1">SID</option>
                                            <option value="2">BID</option>
                                            <option value="3">TID</option>
                                            <option value="4">QID</option>
                                        </select>
                                    </td>
                                    <td class="text-right" style="vertical-align: middle;">
                                        Repeat In
                                    </td>
                                    <td style="max-width: 80px;">
                                        <input type="number" class="form-control" name="Tx_RepeatIn_{{ index }}"
                                            [(ngModel)]="procedureService.tx_setup_array[index].repeat_in" />
                                    </td>
                                    <td class="text-right" style="vertical-align: middle;">
                                        Total Treatments
                                    </td>
                                    <td style="max-width: 80px;">
                                        <input type="number" class="form-control" name="Tx_TotalTreatments_{{ index }}"
                                            [(ngModel)]="procedureService.tx_setup_array[index].total_times" />
                                    </td>
                                    <td class="text-right" style="vertical-align: middle;">
                                        Total Days
                                    </td>
                                    <td style="max-width: 80px;">
                                        <input type="number" class="form-control" name="Tx_TotalDays_{{ index }}"
                                            [value]="getDaysTreatment(index)" />
                                    </td>
                                    <td class="text-right" style="vertical-align: middle;">
                                        <span *ngIf="index == 0">Create Now</span>
                                    </td>
                                    <td>
                                        <input *ngIf="index == 0" type="checkbox" class="form-control"
                                            name="Tx_CreateNow_{{ index }}"
                                            [(ngModel)]="procedureService.tx_setup_array[index].immediately" />
                                    </td>
                                    <td class="text-right" style="vertical-align: middle;">
                                        <span *ngIf="index == 0">Create Next Scheduled</span>
                                    </td>
                                    <td>
                                        <input *ngIf="index == 0" type="checkbox" class="form-control"
                                            name="Tx_CreateNext_{{ index }}"
                                            [(ngModel)]="procedureService.tx_setup_array[index].next" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary font-weight-bold">
                        Save
                    </button>
                    <button type="button" class="btn btn-secondary mx-5" data-bs-dismiss="modal"
                        aria-label="Close">Cancel</button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- RESP NOTES MODAL -->
<div class="modal fade" id="modalRespNotes" tabindex="-1" role="dialog" aria-labelledby="modalRespNotesLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modalRespNotesLabel">Results</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <i aria-hidden="true" class="ki ki-close"></i>
                </button>
            </div>
            <div class="modal-body">
                <div class="table-responsive">
                    <table class="table table-bordered table-sm align-middle">
                        <thead class="table-dark">
                            <tr>
                                <th>Exam</th>
                                <th>Result</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let note of respNotes; let i = index">
                                <td style="white-space: nowrap;">{{ note.note_text }}</td>
                                <td>
                                    <input type="text" class="form-control form-control-sm"
                                        [(ngModel)]="respNotes[i].note_value" [name]="'note_value_' + i" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary font-weight-bold"
                    (click)="updateRespNotes(respNotes)">Save</button>
                <button type="button" class="btn btn-secondary mx-2" data-bs-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>